import { createRouter, createWebHistory } from "vue-router";
import Layout from '@/layout/index.vue'
 
// 1. 配置路由
export const constantRoutes= [
  
  {
    path: "/login", // 默认路由 home页面
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/findpassword", // 忘记密码页面
    component: () => import("@/views/findpwd.vue")
  },
  {
		path: '/',
		component: Layout,
		redirect: 'index',
    img:'homepage.png',
		name: '首页',
    icon:'icon-shouye',
    parentId:0,
    id:1283,
		meta: {
			title: '首页',
			affix: true
		},
    children: [
      {
        path: '/index',
        name: '数据大屏',
        component: () => import('@/views/home/index.vue'),
        parentId:1283,
        id:1284,
        meta: {
          title: '数据大屏',
          affix: true
        }
      }
    ],
	},
  {
    path: '/shop',
    name: '店铺管理',
    icon:'icon-dianpu2',
    component: Layout,
    img:"shop.png",
    meta: {
      title: '店铺管理'
    },
    parentId:0,
    id:1293,
    children: [
      {
        path: '/shop/shop',
        name: '店铺管理',
        component: () => import('@/views/shop/shop.vue'),
        meta: {
          title: '店铺管理'
        },
        parentId:1293,
        id:1294
      },
    ]
  },
  {
    path: '/clue',
    name: '线索管理',
    icon:'icon-dianpu2',
    component: Layout,
    img:"shop.png",
    meta: {
      title: '线索管理'
    },
    parentId:0,
    id:1700,
    children: [
        {
          path: '/clue/order',
          name: '订购单管理',
          component: () => import('@/views/clue/order.vue'),
          meta: {
            title: '订购单管理'
          },
          parentId:1700,
          id:1701
        },
        {
          path: '/clue/sample',
          name: '申样管理',
          component: () => import('@/views/clue/sample.vue'),
          meta: {
            title: '申样管理'
          },
          parentId:1700,
          id:1702
        },
        {
          path: '/clue/inquiry',
          name: '询单管理',
          component: () => import('@/views/clue/inquiry.vue'),
          meta: {
            title: '询单管理'
          },
          parentId:1700,
          id:1703
        }
    ]
  },
  {
    path: '/product',
    name: '商品管理',
    img:"product.png",
    component: Layout,
    icon:'icon-chanpinguanli',
    meta: {
      title: '商品管理'
    },
    parentId:0,
    id:1297,
    children: [
      {
        path: '/product/product',
        name: '商品管理',
        component: () => import('@/views/product/product.vue'),
        meta: {
          title: '商品管理'
        },
        parentId:1297,
        id:1298,
      },
      {
        path: '/product/productDetail',
        name: '商品详情',
        component: () => import('@/views/product/productDetail.vue'),
        meta: {
          title: '商品详情'
        },
        hidden: true,
        parentId:1297,
        id:1400
      },
      {
        path: '/product/publishproduct',
        name: '发布商品',
        component: () => import('@/views/product/publishProduct.vue'),
        meta: {
          title: '发布商品'
        },
        parentId:1297,
        id:180
      },
      {
        path: '/product/editproduct',
        name: '编辑商品',
        component: () => import('@/views/product/editProduct.vue'),
        meta: {
          title: '编辑商品'
        }
      }
    ]
  },
  {
    path: '/message',
    img:"message.png",
    name: '消息管理',
    icon:'icon-duanxinguanli',
    component: Layout,
    parentId:0,
    id:1342,
    meta: {
      title: '消息管理'
    },
    children: [
      {
        path: '/message/onlineservice',
        name: '客服消息',
        component: () => import('@/views/message/onlineservice/index.vue'),
        meta: {
          title: '客服消息'
        },
        parentId:1342,
        id:1343
      },
      {
        path: '/message/chat',
        name: 'im消息',
        component: () => import('@/views/message/onlineservice/chat.vue'),
        meta: {
          title: 'im消息'
        },
        parentId:1342,
        id:8888
      },
      {
        path: '/message/systerm',
        name: '系统消息',
        component: () => import('@/views/message/systerm/index.vue'),
        meta: {
          title: '系统消息'
        },
        parentId:1342,
        id:9999
      }
      // {
      //   path: '/message/systerm/detail',
      //   name: '系统详情',
      //   component: () => import('@/views/message/systerm/detail.vue'),
      //   meta: {
      //     title: '系统详情'
      //   },
      //   hidden: true,
      //   parentId:1342,
      //   id:1346
      // }
    ]
  },
  {
    img:"set.png",
    path: '/system',
    name: '系统管理',
    parentId:0,
    id:1358,
    component: Layout,
    icon:'icon-shezhi',
    meta: {
      title: '系统管理'
    },
    children: [
      {
        path: '/system/employee',
        name: '员工管理',
        component: () => import('@/views/system/employee/index.vue'),
        meta: {
          title: '员工管理'
        },
        parentId:1358,
        id:1359
      },
      {
        path: '/system/employee/add',
        name: '新增员工',
        component: () => import('@/views/system/employee/add.vue'),
        meta: {
          title: '新增员工'
        },
        hidden: true,
        parentId:1358,
        id:1360  
      },
      {
        path: '/system/employee/edit',
        name: '编辑员工',
        component: () => import('@/views/system/employee/edit.vue'),
        meta: {
          title: '编辑员工'
        },
        hidden: true,
        parentId:1358,
        id:1361  
      },
      {
        path: '/system/employee/detail',
        name: '员工详情',
        component: () => import('@/views/system/employee/detail.vue'),
        meta: {
          title: '员工详情'
        },
        hidden: true,
        parentId:1358,
        id:1900
      },
      {
        path: '/system/role',
        name: '角色管理',
        component: () => import('@/views/system/role/index.vue'),
        meta: {
          title: '角色管理'
        },
        parentId:1358,
        id:1362
      },
      {
        path: '/system/role/add',
        name: '新建角色',
        component: () => import('@/views/system/role/add.vue'),
        meta: {
          title: '新建角色'
        },
        hidden: true,
        parentId:1358,
        id:1363
      },
      {
        path: '/system/role/edit',
        name: '编辑角色',
        component: () => import('@/views/system/role/edit.vue'),
        meta: {
          title: '编辑角色'
        },
        hidden: true,
        parentId:1358,
        id:1364
      },
      {
        path: '/system/address',
        name: '地址管理',
        component: () => import('@/views/system/address/index.vue'),
        meta: {
          title: '地址管理'
        },
        parentId:1358,
        id:1600
      },
      {
        path: '/system/address/add',
        name: '新建地址',
        component: () => import('@/views/system/address/add.vue'),
        meta: {
          title: '新建地址'
        },
        hidden: true,
        parentId:1358,
        id:1601
      },
      {
        path: '/system/address/edit',
        name: '编辑地址',
        component: () => import('@/views/system/address/edit.vue'),
        meta: {
          title: '编辑地址'
        },
        hidden: true,
        parentId:1358,
        id:1602
      },
      {
        path: '/system/accont',
        name: '账号管理',
        component: () => import('@/views/system/accont/index.vue'),
        meta: {
          title: '账号管理'
        },
        parentId:1358,
        id:7777
      },
    ]
  }
];
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), 
  routes:constantRoutes,
});
 
export default router

